import { createContext, use, useState } from "react";
import type { FC, ReactNode } from "react";
import type { QuestionUpdates } from "../../../api/templateFormSettings.types";

/** This context is used to pass extra state to the Template settings shared.
 * Information that is not a part of the react-hook-form */
type TemplateFormSectionsState = {
  pendingChanges: QuestionUpdates[];
  addPendingChanges: (questionUpdates: QuestionUpdates[]) => void;
  clearPendingChanges: () => void;
};
const TemplateStateContext = createContext<TemplateFormSectionsState | undefined>(undefined);

type TemplateFormSectionsProviderProps = {
  children: ReactNode;
};
export const TemplateProvider: FC<TemplateFormSectionsProviderProps> = ({ children }) => {
  const [pendingChanges, setPendingChanges] = useState<QuestionUpdates[]>([]);

  const templateFormSectionsState: TemplateFormSectionsState = {
    pendingChanges,
    addPendingChanges: setPendingChanges,
    clearPendingChanges: () => setPendingChanges([]),
  };

  return <TemplateStateContext value={templateFormSectionsState}>{children}</TemplateStateContext>;
};

export const useTemplateFormSectionsState = () => {
  const context = use(TemplateStateContext);
  if (!context) throw new Error('"useFormSettingsState" can only be used within a "FormSettingsProvider');
  return context;
};
